import React, { Component } from 'react';
import AdminSalesForceAuditTable from './AdminSalesForceAuditTable';

export class AdminSalesForceAuditSFBMContent extends Component {
  render() {

    return (
      <AdminSalesForceAuditTable titleTableList={this.props.titleTableList} tableList={this.props.tableList} />
    )
  }
}

export default AdminSalesForceAuditSFBMContent


// WEBPACK FOOTER //
// ./src/components/Administration/AdminSalesForceAudit/AdminSalesForceAuditSFBMContent.js